import { FormattedMessage } from 'react-intl'

import useApp from '~/App/slice/useApp'

import { IncomingMessage } from './IncomingMessage'
import MessageText from './MessageText'

function WelcomeMessage() {
  const { widget } = useApp()
  return (
    <IncomingMessage direction="none" variant="tertiary">
      {widget?.attributes.opening ? (
        <MessageText>{widget.attributes.opening.message}</MessageText>
      ) : (
        <FormattedMessage id="chat.welcomeMessage.content" />
      )}
    </IncomingMessage>
  )
}

export default WelcomeMessage
